import React from 'react';
import styles from './CloseButton.scss';
import classNames from 'classnames/bind';
import {Typography} from '../index';

const cx = classNames.bind(styles);

const CloseButton = ({
  onClick,
  children,
}) => {
  return (
    <div className={cx('CloseButton')} onClick={() => onClick({isFinish: true})}>
      <Typography styles={{color: '#64c2e6'}}>
        {children}
      </Typography>
    </div>
  );
};

export default CloseButton;


// WEBPACK FOOTER //
// ./src/app/intro/components/CloseButton/CloseButton.js